import { css } from '@emotion/react';
import { hexToRgba } from '../helpers';
import { theme } from '../theme';
import { tokens } from '../tokens';
const notificationStaticStyle = css({
    backgroundColor: theme.background.contrast,
    borderRadius: tokens.borderRadius.medium,
    display: 'flex',
    padding: '12px',
    position: 'relative',
});
export function notificationStyle({ variant }) {
    const borderColor = hexToRgba(variant === 'warning' ? theme[variant].lighter : theme[variant].main, 0.6);
    return [
        notificationStaticStyle,
        css({
            border: `${tokens.borderWidth.thin} solid ${borderColor}`,
        }),
    ];
}
const contentStaticStyle = css({
    alignSelf: 'center',
    paddingLeft: tokens.spacingNew.xsmall,
});
export function contentStyle({ closable, isContentCentered, }) {
    return [
        contentStaticStyle,
        closable && css({ paddingRight: tokens.spacingNew.xsmall }),
        !isContentCentered && css({ flexGrow: 1 }),
    ];
}
export const closeButtonStaticStyle = css({
    color: theme.text.main,
    flexShrink: 0,
    marginLeft: 'auto',
});
